import { dateTimeBR } from "../../lib/format";

const ST = { sent: ["ENVIADO", "bg-emerald-100 text-emerald-800"], failed: ["FALHOU", "bg-rose-100 text-rose-800"], pending: ["PENDENTE", "bg-amber-100 text-amber-800"], generated: ["LINK GERADO", "bg-sky-100 text-sky-800"] };

export function EmailHistory({ emails }) {
  if (!emails?.length) return null;
  return (
    <details className="text-xs" data-testid="email-history">
      <summary className="cursor-pointer text-slate-500 hover:text-slate-800 transition-colors" data-testid="email-history-toggle">Histórico de envios ({emails.length})</summary>
      <ul className="mt-2 divide-y divide-slate-100 rounded-md border border-slate-200 bg-white">
        {emails.map((e) => {
          const [label, cls] = ST[e.result] || [e.result, "bg-slate-100 text-slate-700"];
          return (
            <li key={e.id} className="p-2 space-y-0.5" data-testid={`email-log-${e.id}`}>
              <div className="flex flex-wrap items-center gap-2">
                <span className={`px-1.5 py-0.5 rounded font-bold ${cls}`} data-testid={`email-log-status-${e.id}`}>{label}</span>
                <span className="text-slate-700">{e.type_label || "Acesso / primeiro acesso"}</span>
                <span className="text-slate-400 ml-auto">{dateTimeBR(e.at)}</span>
              </div>
              <div className="text-slate-600">Para: <b>{e.to}</b>{e.user_name ? ` (${e.user_name})` : ""} · por {e.by}</div>
              {e.from && <div className="text-slate-500">Remetente: {e.from}{e.reply_to ? ` · resposta para ${e.reply_to}` : ""}</div>}
              {e.provider_id && <div className="text-slate-500">ID do provedor: <code>{e.provider_id}</code> · aceito pelo provedor</div>}
              {e.error && <div className="text-rose-700">Erro técnico: {e.error}</div>}
            </li>);
        })}
      </ul>
    </details>);
}
